var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"project42-floating-button",attrs:{"type":"button"},on:{"click":_vm.openModal}},[_c('span',{staticClass:"project42-floating-button__text"},[_vm._v(_vm._s(_vm.text))]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project42-floating-button__circle"},[_c('span',{staticClass:"project42-floating-button__circle__icon icon-star"})])
}]

export { render, staticRenderFns }